document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-carousel-track]").forEach(track => {
    const wrapper = track.closest(".l2-carousel-wrapper");
    const prev = wrapper.querySelector(".carousel-arrow.prev");
    const next = wrapper.querySelector(".carousel-arrow.next");

    const scrollAmount = track.offsetWidth * 0.8;

    prev?.addEventListener("click", () => {
      track.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    });

    next?.addEventListener("click", () => {
      track.scrollBy({ left: scrollAmount, behavior: "smooth" });
    });

    /* DRAG SUPPORT */
    let isDown = false;
    let startX, scrollLeft;

    track.addEventListener("mousedown", e => {
      isDown = true;
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
      track.classList.add("dragging");
    });

    track.addEventListener("mouseleave", () => isDown = false);
    track.addEventListener("mouseup", () => isDown = false);

    track.addEventListener("mousemove", e => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 1.2;
      track.scrollLeft = scrollLeft - walk;
    });
  });
});
